import { baseApiInstance, baseApiInstanceWithRefresh } from './baseApiInstance';
import { SLIDES_DELETE_URL, SLIDES_REPORT_URL } from './urls';

/**
 * Запрашивает отчет по выбранным слайдам в формате Excel
 * @param {number[]} slideIds - ID слайдов в порядке выбора
 * @returns {Promise<Blob>} - содержимое файла .xlsx
 */
export const downloadSlidesReport = async (slideIds) => {
    const response = await baseApiInstanceWithRefresh.post(
        SLIDES_REPORT_URL,
        { ids: slideIds },
        { responseType: 'blob' }
    );

    return response.data;
};

/**
 * Удаляет выбранные слайды вместе с файлами и аннотациями
 * @param {number[]} slideIds - ID слайдов
 * @returns {Promise<Object>} - {deleted, deleted_count, not_found, errors}
 */
export const deleteSlides = async (slideIds) => {
    const response = await baseApiInstanceWithRefresh.post(SLIDES_DELETE_URL, {
        ids: slideIds,
    });

    return response.data;
};

/**
 * Обновляет task_id для указанного слайда
 * @param {number} slideId - ID слайда
 * @param {string} taskId - ID задачи обработки
 * @returns {Promise} - Результат обновления
 */
export const updateSlideTaskId = async (slideId, taskId) => {
    try {
        const response = await baseApiInstance.patch(`/api/slide/${slideId}/update-task/`, {
            id_task: taskId
        });
        
        return response.data;
    } catch (error) {
        console.error(`❌ API Error updating slide ${slideId} task_id:`, error);
        console.error(`❌ Error details:`, error.response?.data);
        console.error(`❌ Error status:`, error.response?.status);
        throw error;
    }
};
